import React, { useEffect, useMemo, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Center } from '@mantine/core';
import Tilt from 'react-parallax-tilt';

import { Progress } from '@mantine/core';

const ManageProgress = (props) => {
    const dispatch = useDispatch();

    const epoch = useSelector(state => state.mainapp.stakingSlice.epoch)
    const stakingEarnedAmount = useSelector((state) => state.mainapp.stakingSlice.earnings)
    const stakedAt = useSelector((state) => state.mainapp.stakingSlice.stakingTime)
    const userIndex = useSelector((state) => state.mainapp.stakingSlice.userIndex)
    const unstakeLimits = useSelector((state) => state.mainapp.stakingSlice.unstakeLimits)
    const validMarkerPosition = Math.min(100, Math.max(0, 80));
    const markerText = 'Unstake Lock';

    let progressMeter = useMemo(() => {
        if (unstakeLimits.limit == unstakeLimits.count) return 100
        const progressMeter = unstakeLimits.count / (unstakeLimits.limit * .8) * 100
        return Math.min(100, Math.max(0, progressMeter));
    }, [epoch])

    let unstakeDayDifference = useMemo(() => {

        return Math.max(0, Math.ceil((new Date(stakedAt) - Date.now()) / (1000 * 60 * 60 * 24)));
    }, [stakedAt])






    return (
        <>
            <div className='manage-progress'>
                <h2>Manage Progress</h2>
                <div className='manage-progress-bar'>
                    <div className='magage-progress-title'>

                        {progressMeter == 100 ? <><i className='material-icons'>error</i><h2>Unstake Unavailable</h2></> : <>{
                            unstakeDayDifference > 0 ? <><i className='material-icons'>error</i><h2>Unstake Unavailable</h2></> : <><i className='material-icons'>check_circle</i><h2>Unstake Available</h2> </>}</>}

                    </div>
                    <div className='manage-progress-bar-item' style={{ position: 'relative' }}>
                        <Progress color={
                            progressMeter == 100 && unstakeDayDifference > 0 ? 'rgba(255, 255, 255, 0.039);' : '#FF7612'
                        } radius="xl" size="xl" value={progressMeter} />
                        <div className='progress-marker' style={{ left: `${validMarkerPosition}%` }}></div>
                        <div className='progress-marker-text' style={{ left: `calc(${validMarkerPosition}% - 36px)` }}>
                            {markerText}
                        </div>
                    </div>

                </div>

                <div className='text-chips'>
                    {progressMeter == 100 ?
                        <>
                            <div className='text-chip'>
                                <h4>Unstake Unavailable</h4>
                                <p>Cannot unstake when threshold is above lock.</p>
                            </div>
                            <div className='text-chip'>
                                <h4>{`${unstakeLimits.count} of ${unstakeLimits.limit}`}</h4>
                                <p>{`The unstake lock is in effect. New lock generated in ${Math.max(0, Math.ceil((new Date(unstakeLimits.lastContainerTimestamp) - Date.now()) / (1000 * 60 * 60 * 24)))} days.`} </p>
                            </div>

                        </>

                        :

                        <>
                            <div className='text-chip'>
                                <h4>Unstake Available</h4>
                                <p>The ability to unstake is available.</p>
                            </div>
                            <div className='text-chip'>
                                <h4>{`${unstakeLimits.count} of ${unstakeLimits.limit}`}</h4>
                                <p>The unstake lock is not in effect. </p>
                            </div>

                        </>

                    }

                </div>
            </div>
            <style>{
                progressMeter == 100 && unstakeDayDifference > 0 ?
                    `   
                  .magage-progress-title > i {
                    color: var(--frostedBackground)
                    }

                    .text-chips {
                        opacity: 0.5;
                    }
                    `
                    :
                    null
            }</style>
        </>
    );
};

export default ManageProgress